export default __webpack_public_path__ + "static/media/car-painting.e10ebad0.png";